import { FaArrowDownLong, FaArrowUpLong } from "react-icons/fa6";
import CardLayout from "../../common/CardLayout";
import NoDataAlert from "../../common/returns/NoDataAlert";
import { GaugeChart } from "./charts/GaugeChart";

export default function ArComprimidoCard({arComprimido, leituraArComprimido, key}) {	
	
	function getLeituraByArComprimido(id) {
		return leituraArComprimido.find(
			(elemento) => elemento.arComprimidoId === id
		);
	}
	
	function isAlarmed(arComprimidoEqui) {
		const pressaoAtual = getLeituraByArComprimido(arComprimidoEqui.id)?.pressao;
		if (
			pressaoAtual < arComprimidoEqui.rangeMin ||
			pressaoAtual > arComprimidoEqui.rangeMax
		) {
			return true;
		}
		return false;
	}

	return (
		<CardLayout key={key} alarmed={isAlarmed(arComprimido)} className={"bg-accent/20"}>
			<div
				className={`flex flex-col justify-center items-center ${arComprimido.color}`}
			>
				<div className="py-2 lg:pt-2 lg:pb-1 text-lg 3xl:text-3xl font-semibold drop-shadow-1xl uppercase">
					{arComprimido.nome}
				</div>
			</div>
			<div className="flex flex-row w-full flex-wrap justify-center gap-x-[15%]">
				<div className="flex flex-col justify-center items-center">
					<div className="drop-shadow-2xl">
						<p className="text-md font-normal text-secondary">
							Ponto ótimo:{' '}
							<span className="font-bold drop-shadow-1xl text-white text-lg">
								{
									arComprimido.pressaoReferencia?.toLocaleString(
										'pt-BR',
										{
											maximumFractionDigits: 2,
										}
									)
								}
								{' Bar'}
							</span>
						</p>
					</div>
					<div className="flex justify-center items-center">
						{getLeituraByArComprimido(arComprimido.id)
							?.pressao !==
							undefined ? (
							<GaugeChart
								regime={arComprimido}
								pressaoAtual={
									getLeituraByArComprimido(
										arComprimido.id
									)
										?.pressao
								}
							/>
						) : (
							<div className="pt-8">
								<NoDataAlert />
							</div>
						)}
					</div>
					<div className="flex flex-row justify-around w-full max-w-2xl text-secondary text-xs px-4 py-2">
						<p className="text-secondary text-lg">
							{arComprimido.rangeMin?.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							)} {' Bar'}
						</p>
						<p className="text-secondary text-lg">
							{arComprimido.rangeMax?.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							)} {' Bar'}
						</p>
					</div>
				</div>
				<div className="flex justify-center items-center flex-col text-secondary font-normal text-left py-2">
					<div className="text-secondary inline-flex text-sm 3xl:text-lg p-1">
						<FaArrowUpLong className="w-4 h-4 text-accent 3xl:w-5 3xl:h-5" />
						Max. registrada:{' '}
						<span className="font-semibold drop-shadow-1xl text-white px-1">
							{getLeituraByArComprimido(
								arComprimido.id
							)?.pressaoMaximaRegistrada.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							) ?? 0}
						</span>
					</div>
					<div className="text-secondary inline-flex text-sm 3xl:text-lg p-1">
						<FaArrowDownLong className="w-4 h-4 text-accent 3xl:w-5 3xl:h-5" />
						Min. registrada:{' '}
						<span className="font-semibold drop-shadow-1xl text-white px-1">
							{getLeituraByArComprimido(
								arComprimido.id
							)?.pressaoMinimaRegistrada.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							) ?? 0}
						</span>
					</div>
					{/* <div className="flex text-center justify-center border-2 items-center border-accent rounded-full h-8 w-full max-w-[20rem] 3xl:px-4 my-2">
						<div className="text-secondary font-normal">
							<div className="flex text-center justify-center text-secondary items-center">
								<p
									className={`text-sm 3xl:text-lg font-bold px-4 ${arComprimido.color}`}
								>
									Temperatura:
								</p>
								<span className="font-bold drop-shadow-1xl text-white px-4 md:px-2 text-sm 3xl:text-lg">
									{getLeituraByArComprimido(
										arComprimido.id
									)?.temperaturaAtual?.toLocaleString(
										'pt-BR',
										{
											maximumFractionDigits: 1,
										}
									)}
									<span>
										°C
									</span>
								</span>
							</div>
						</div>
					</div> */}
				</div>
			</div>
		</CardLayout>
	)
}